/**
 * record-info — карточка «Информация о записи»: название, канал, участник,
 * проект, дата, id. Зеркалит старую `pdf.sections.recordInfo` из
 * `printReport.ts` (задача 12 удалит оригинал), но собрана поверх примитивов
 * задачи 4 вместо инлайновых стилей.
 */
import { card, kvRow } from '../primitives';
import { escapeHtml } from '../escape';
import type { SectionFn } from '../types';
import { formatDateShort } from '@/lib/utils';

export const renderRecordInfo: SectionFn = (input, t) => {
  const { record } = input;
  const shortId = record.id.slice(0, 8);
  const title =
    record.participantName ?? t('records.recordTitleFallback', { id: shortId });
  const project = record.projectName ?? record.projectId;
  // "Неизвестно", а не прочерк: участник у звонка был всегда, просто имя не
  // разрешилось — это не то же самое, что «метрика неприменима»
  // (nullableScore в primitives.ts). Тот же ключ, которым пользовался старый
  // printReport.ts (pdfExportHelpers.ts) — есть во всех четырёх локалях.
  const participant = record.participantName
    ? escapeHtml(record.participantName)
    : escapeHtml(t('common:common.unknown'));

  const rows = [
    kvRow(t('pdf.fields.title'), escapeHtml(title)),
    kvRow(t('pdf.fields.channel'), escapeHtml(t(`pdf.channel.${record.type}`))),
    kvRow(t('pdf.fields.participant'), participant),
    kvRow(t('pdf.fields.project'), escapeHtml(project)),
    kvRow(t('pdf.fields.date'), escapeHtml(formatDateShort(record.createdAt))),
    kvRow(t('pdf.fields.recordId'), `${escapeHtml(shortId)}…`),
  ];

  return card({
    title: t('pdf.sections.recordInfo'),
    body: rows.join(''),
  });
};
